import type HttpClient from "../../tastyworks/http"
import {
  JOURNAL_ENTRY_DESER,
  JournalEntry,
} from "../../tastyworks/journal-entry"
import type { Params } from "../../tastyworks/request"
import type {
  BaseResponse,
  ItemsResponse,
  SingleResponse,
} from "../../tastyworks/response"

export class JournalEntryService {
  private readonly journalClient: HttpClient

  constructor(baseHttpClient: HttpClient) {
    this.journalClient = baseHttpClient.nested("journal-entries")
  }

  readonly index = async (
    params?: Params
  ): Promise<ItemsResponse<JournalEntry>> =>
    this.journalClient.indexSimple(
      JOURNAL_ENTRY_DESER.toParser(JournalEntry),
      "",
      params
    )

  readonly create = async (
    entry: JournalEntry
  ): Promise<SingleResponse<JournalEntry>> => {
    return this.journalClient.create(
      entry,
      JOURNAL_ENTRY_DESER.serialize,
      JOURNAL_ENTRY_DESER.update
    )
  }

  readonly update = async (
    entry: JournalEntry
  ): Promise<SingleResponse<JournalEntry>> => {
    return this.journalClient.update(
      entry,
      JOURNAL_ENTRY_DESER.serialize,
      JOURNAL_ENTRY_DESER.update,
      `/${entry.id}`
    )
  }

  readonly destroy = async (id: string): Promise<BaseResponse> => {
    return this.journalClient.destroy(id)
  }
}
